import { actionTypes } from '../actionTypes';
import * as  apiService from '../apiService';

export function fetchsubscriptionReports(reportsType: any) {

    const reportType: string = 'ReportType';
    const filterType: string = 'FilterType';
    const filterValue: string = 'FilterValue'
    return (dispatch: any) => {
        dispatch(fetchSubscriptionsBegin());
        return fetch(apiService.subscriptionReport())
            .then(handleErrors)
            .then(res => res.json())
            .then(json => {
                if (reportsType === 'allUsers') {
                    dispatch(fetchSubscriptionsSuccess(json.data));
                }
                if (reportsType === 'archived') {
                    dispatch(getArchievedReports(json.data));
                }
                if (reportsType === 'allUserNoRR') {
                    dispatch(getAllUserNoRRReports(json.data));
                }
                if (reportsType === 'allSubscriptions') {
                    dispatch(getAllSubscriptionsReports(json.data));
                }
                if (reportsType === 'subscriptionsByDate') {
                    dispatch(getSubscriptionsByDateReports(json.data));
                }
                if (reportsType === 'expiredUsers') {
                    dispatch(getExpiredUsersReports(json.data));
                }
                if (reportsType === 'expiredIn30days') {
                    dispatch(getExpired30DaysReports(json.data));
                }
                if (reportsType === 'expiredIn120days') {
                    dispatch(getExpired120DaysReports(json.data));
                }
                if (reportsType === 'allTSLiveReport') {
                    dispatch(getAllTSLiveReports(json.data));
                }
                if (reportsType === 'specialBillingReports') {
                    dispatch(getSpecialBillingReports(json.data));
                }
                if (reportsType === 'listOfIrvineAccounts') {
                    dispatch(getListofIrvineAccounts(json.data));
                }
                if (reportsType === 'listOfRedyRefAccounts') {
                    dispatch(getListOfRedyRefAccounts(json.data));
                }
                if (reportsType === 'cancelledUsersReport') {
                    dispatch(getCancelledUserReports(json.data));
                }
                if (reportsType[reportType] === 'subscriptionFilter') {
                    dispatch(filterExpiredUserDataByFilter(json.data, reportsType[filterType], reportsType[filterValue]))
                }
                dispatch(getSubscriptionReportSuccess());
                return json.data;
            })
            .catch(error => dispatch(fetchSubscriptionsFailure(error)));
    };
}

export const fetchSubscriptionsBegin = () => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_BEGIN
});

export const getSubscriptionReportSuccess = () => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_SUCCESS
})

export const fetchSubscriptionsSuccess = (subscriptionReports: any) => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_SUCCESS,
    payload: { subscriptionReports }
});

export const fetchSubscriptionsFailure = (error: any) => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_FAILURE,
    payload: { error }
});

export const getArchievedReports = (subscriptionReports: any) => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_ARCHIVED,
    payload: { subscriptionReports }
})

export const getAllUserNoRRReports = (subscriptionReports: any) => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_ALL_USERS_NO_RR,
    payload: { subscriptionReports }
})

export const getAllSubscriptionsReports = (subscriptionReports: any) => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_ALL_SUBSCRIPTIONS,
    payload: { subscriptionReports }
})

export const getSubscriptionsByDateReports = (subscriptionReports: any) => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_SUBSCRIPTIONS_DATE,
    payload: { subscriptionReports }
})

export const getExpiredUsersReports = (subscriptionReports: any) => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_EXPIRED_USERS,
    payload: { subscriptionReports }
})

export const getExpired30DaysReports = (subscriptionReports: any) => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_30_DAYS,
    payload: { subscriptionReports }
})

export const getExpired120DaysReports = (subscriptionReports: any) => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_120_DAYS,
    payload: { subscriptionReports }
})

export const getAllTSLiveReports = (subscriptionReports: any) => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_ALL_TSLIVE,
    payload: { subscriptionReports }
})

export const getSpecialBillingReports = (subscriptionReports: any) => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_ALL_SPECIAL_BILLING,
    payload: { subscriptionReports }
})

export const getListofIrvineAccounts = (subscriptionReports: any) => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_IRVINE_ACCOUNTS,
    payload: { subscriptionReports }
})

export const getListOfRedyRefAccounts = (subscriptionReports: any) => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_REDYREF_ACCOUNTS,
    payload: { subscriptionReports }
})

export const getCancelledUserReports = (subscriptionReports: any) => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_CANCELLED_USER,
    payload: { subscriptionReports }
})

export const fetchDatebyDateChange = (date: any) => ({
    type: actionTypes.LOAD_SUBSCRIPTION_REPORTS_SUBSCRIPTIONS_BY_DATE,
    payload: { date }
})

export const filterExpiredUserDataByFilter = (subscriptionReports: any, filter: any, filterValue: any) => ({
    type: actionTypes.LOAD_EXPIRED_USER_REPORTS__BY_FILTER,
    payload: { subscriptionReports, filter, filterValue }
})


export function filterExpiredUsers(reportsType: any) {
    return (dispatch: any) => {
        dispatch(filterExpitedUsers(reportsType));
    }
}

export const filterExpitedUsers = (reportsType:any) => ({
    type: actionTypes.LOAD_EXPIRED_USER_REPORTS__BY_FILTER,
    filterType: reportsType
})

// Handle HTTP errors since fetch won't.
function handleErrors(response: any) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}


// WEBPACK FOOTER //
// ./src/store/subscriptionReports/actions.ts